import { render, staticRenderFns } from "./productEditCard.vue?vue&type=template&id=420e35a0&scoped=true"
import script from "./productEditCard.vue?vue&type=script&lang=js"
export * from "./productEditCard.vue?vue&type=script&lang=js"
import style0 from "./productEditCard.vue?vue&type=style&index=0&id=420e35a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420e35a0",
  null
  
)

export default component.exports